import React from 'react';
import { TransformCTA } from '../TransformCTA';
import { KARITO_PHOTO } from '../../data/content';
export function About() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-58" data-mp="oqm5bqr6w7i1">
      <div className="mx-auto w-full max-w-4xl" data-id="element-59" data-mp="12rf08clel4lo">
        <h2 className="text-center font-display text-[26px] font-black leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-60" data-mp="12oswyp5jpb99">
          🩺 Sobre la Dra. Karito
        </h2>

        <div className="mt-9 grid items-start gap-7 md:grid-cols-[minmax(0,320px)_1fr]" data-id="element-61" data-mp="b0irno6dlm47">
          <figure className="mx-auto w-full max-w-[300px] md:max-w-none" data-id="element-62" data-mp="61pejwv03x4k">
            <img src={KARITO_PHOTO} alt="Retrato de la Dra. Karito, médica creadora de Ruta Hipotiroidismo" className="w-full rounded-3xl border border-navy-100 object-cover shadow-lg shadow-navy-900/10" data-id="element-63" data-mp="jskprfsz2qbb" />
            <figcaption className="mt-3 text-center text-[13px] font-semibold text-navy-800/70" data-id="element-64" data-mp="3nf1fbdv5jiwg">
              Dra. Karito · Creadora de Ruta Hipotiroidismo™
            </figcaption>
          </figure>

          <div className="space-y-4 text-[15px] leading-relaxed text-navy-800/85 sm:text-lg" data-id="element-65" data-mp="3375nhgv09tuk">
            <p data-id="element-66" data-mp="3868j6ap3inpv">
              Como médica, conozco perfectamente esa sensación de estar frente a
              un paciente con una TSH alterada y descubrir que, incluso después
              de revisar varias guías, la respuesta que necesitas para ese caso
              específico sigue sin ser completamente clara.
            </p>
            <p className="font-semibold text-navy-950" data-id="element-67" data-mp="2p97gwxmxf1pm">
              Por eso decidí crear Ruta Hipotiroidismo™.
            </p>
            <p data-id="element-68" data-mp="2u7iqr8d81c7u">
              No como otro manual para leer de principio a fin. Sino como un
              sistema práctico que organiza el proceso diagnóstico, terapéutico
              y de seguimiento en una secuencia lógica que puedas consultar
              justo cuando más lo necesitas.
            </p>
            <p data-id="element-69" data-mp="eg39fclpt33x">
              Mi objetivo nunca fue enseñarte más teoría. Fue ayudarte a tomar
              mejores decisiones clínicas con mayor rapidez, seguridad y
              confianza.
            </p>
            <p className="font-display text-lg font-bold text-navy-950 sm:text-xl" data-id="element-70" data-mp="25ky3qc3ji8pp">
              Porque cuando el médico tiene claridad, el paciente también recibe
              una mejor atención.
            </p>
          </div>
        </div>

        <TransformCTA headline="Lleva a tu consulta el mismo sistema que la Dra. Karito usa cada día." data-id="element-71" data-mp="1rtt6thrk3uj2" />
      </div>
    </section>;
}